<i18n>
{
    "ru": {
        "by_popular": "По популярности",
        "by_rating": "По рейтингу",
        "by_new": "По дате",
        "sort": "Сортировка",
        "filter": "Фильтр",
        "show_replies": "Показать",
        "replies_one": "ответ",
        "replies_few": "ответа",
        "replies_many": "ответов",
        "ratings_one": "оценка",
        "ratings_few": "оценки",
        "ratings_many": "оценок",
        "reviews_one": "отзыв",
        "reviews_few": "отзыва",
        "reviews_many": "отзывов",
        "comments_one": "комментарий",
        "comments_few": "комментария",
        "comments_many": "комментариев",
        "hide_replies": "Скрыть",
        "guest": "Гость",
        "reply": "Ответить",
        "go": "Перейти",
        "show_user_reviews": "Все отзывы пользователя",
        "hide_user_reviews": "Скрыть отзывы пользователя",
        "show_user_comments": "Все комментарии пользователя",
        "hide_user_comments": "Скрыть комментарии пользователя",
        "at": "в",
        "read_more": "Читать полностью...",
        "collapse": "Свернуть",
        "votes_one": "1 звезда",
        "votes_two": "2 звезды",
        "votes_three": "3 звезды",
        "votes_four": "4 звезды",
        "votes_five": "5 звезд",
        "like": "Лайк",
        "itwas": "Был",
        "thereIs": "Есть",
        "want": "Хочу",
        "more": "Ещё",
        "write_review": "Напишите свой отзыв...",
        "show_more": "Показать ещё",
        "info": "Информация",
        "info_text": "На основе {ratings} и {reviews} мы рекомендуем данный аромат. Это может быть хороший подарок!"
    }
}
</i18n>

<template>
    <div class="comments-and-reviews">

        <div class="comments-and-reviews__header-wrapper">
            <div class="comments-and-reviews__column comments-and-reviews__left-column">
                <div v-if="ratings" class="comments-and-reviews__ratings">

                    <div class="comments-and-reviews__value">
                        {{ (ratings.value || 0) | numberFormatRating }}
                    </div>

                    <button class="comments-and-reviews__fire"
                        aria-label="fire"
                        @click="showRecomendation"
                        v-if="asGift">
                        <svg-icon name="icon-flame" />
                    </button>

                </div>

                <div v-if="ratings && ratings.total" 
                    class="comments-and-reviews__stars-wrapper">
                    <div class="comments-and-reviews__stars rating"
                        :data-value="ratings.value | numberFormatRatingHalf"></div>
                    <div class="comments-and-reviews__reviews-count">
                        {{ numberDeclension(ratings.total, 'ratings') }}
                    </div>
                </div>

                <ProgressGroup
                    v-if="showRatingAndVotes"
                    :items="votes"
                    class="comments-and-reviews__votes"
                    checkable
                    with-empties
                    sort-by="name"
                    @rangeClick="onRatingFilterClick"
                    :disabled="false"
                    track-color="orange"/>
            </div>

            <div class="comments-and-reviews__column comments-and-reviews__right-column">
                <div class="comments-and-reviews__right-wrapper">
                    <slot name="right-wrapper"></slot>
                    <div
                        class="comments-and-reviews__shelves-wrapper comments-and-reviews__buttons"
                        v-if="!hideShelfButtons">

                        <ButtonRectangle
                            class="comments-and-reviews__button"
                            bordered
                            :active="perfumeLiked"
                            @click.native="$authEmit('like-perfume', !perfumeLiked)"
                            :icon="isDeviceDesktop ? 'icon-like-colors' : 'icon-heart'">
                            {{ $t('like') }}
                        </ButtonRectangle>

                        <ButtonRectangle
                            class="comments-and-reviews__button comments-and-reviews__button_owner"
                            bordered
                            :active="ownershipStatus === 'itWas'"
                            @click.native="$authEmit('ownership-status-change', 'itWas')"
                            :icon="isDeviceDesktop ? 'icon-clock-colors' : 'icon-clock-current'">
                            {{ $t('itwas') }}
                        </ButtonRectangle>

                        <ButtonRectangle
                            class="comments-and-reviews__button comments-and-reviews__button_owner"
                            bordered
                            :active="ownershipStatus === 'thereIs'"
                            @click.native="$authEmit('ownership-status-change', 'thereIs')"
                            :icon="isDeviceDesktop ? 'icon-check-circle-colors' : 'icon-check-current'">
                            {{ $t('thereIs') }}
                        </ButtonRectangle>

                        <ButtonRectangle
                            class="comments-and-reviews__button comments-and-reviews__button_owner"
                            bordered
                            :active="ownershipStatus === 'want'"
                            @click.native="$authEmit('ownership-status-change', 'want')"
                            :icon="isDeviceDesktop ? 'icon-heart-colors' : 'icon-gift'">
                            {{ $t('want') }}
                        </ButtonRectangle>

                        <div class="comments-and-reviews__shelves"
                            @mouseover="setShelvesShowed(true)"
                            @mouseleave="setShelvesShowed(false)" >

                            <ButtonRectangle
                                class="comments-and-reviews__button"
                                :data-disabled="shelves.length < 1"
                                bordered
                                @click.native="$authEmit('show-user-shelves-tooltip')"
                                :active="!!checkedShelves.length"
                                icon="icon-more-current">
                                {{ $t('more') }}
                            </ButtonRectangle>

                            <div class="comments-and-reviews__shelves-popup">
                                <transition name="slide">
                                    <PerfumeShelves
                                        v-if="popupShelvesShowed && get($auth, 'user.id')"
                                        :is-tooltip="isDeviceDesktop"
                                        v-bind="shelvesParams"/>
                                </transition>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <br v-if="noFilter && !noSort"/>

        <div
            v-if="Object.keys(items).length && !noSort"
            :class="{
                'comments-and-reviews__sort-and-filter_no-padding-top': votes.length < 1,
            }"
            class="comments-and-reviews__sort-and-filter"
            id="comments_filter">

            <transition
                v-if="isDeviceDesktop"
                mode="out-in"
                name="pop">
                <div class="comments-and-reviews__sort-wrapper"
                    @mouseover="popupSortShowed = true"
                    @mouseleave="popupSortShowed = false" >

                    <button class="comments-and-reviews__sort"
                        :key="sort.by + sort.dir"
                        :disabled="!Object.keys(items).length">
                        <span class="comments-and-reviews__sort-title">
                            {{ $t('sort') }}:
                        </span>
                        <span class="comments-and-reviews__sort-type">{{ $t('by_' + sort.by) }}</span>
                        <svg-icon name="icon-chevron-down"
                            class="comments-and-reviews__sort-icon"
                            :class="{
                                'comments-and-reviews__sort-icon_rotated': sort.dir === 'asc'
                            }"/>
                    </button>

                    <transition name="slide">
                        <CommentsSort
                            v-if="popupSortShowed"
                            is-tooltip
                            :sort-type="sort.by"
                            :sort-order="sort.dir"/>
                    </transition>

                </div>
            </transition>

            <transition
                v-else
                mode="out-in"
                name="pop">
                <button class="comments-and-reviews__sort"
                    :key="sort.by + sort.dir"
                    :disabled="!Object.keys(items).length"
                    @click="showSortPopup">
                    {{ $t('sort') }}:
                    <span class="comments-and-reviews__sort-type">{{ $t('by_' + sort.by) }}</span>
                    <svg-icon name="icon-chevron-down"
                        class="comments-and-reviews__sort-icon"
                        :class="{
                            'comments-and-reviews__sort-icon_rotated': sort.dir === 'asc'
                        }"/>
                </button>
            </transition>

            <button class="comments-and-reviews__filter"
                v-if="!noFilter"
                :disabled="!Object.keys(items).length || filters.createdBy"
                @click="showFilter">
                {{ $t('filter') }}
                <span v-if="Object.keys(filters).length && filtersCount">
                    ({{ filtersCount }})
                </span>
                <template v-else>+</template>
            </button>
        </div>

        <div
            class="comments-and-reviews__button-wrapper"
            v-if="showReviewBtn"
            :class="{
                'comments-and-reviews__button-wrapper_empty-review': !visibleIds.length, 
                'comments-and-reviews__button-wrapper_no-votes': !showRatingAndVotes
            }">
            <button
                class="comments-and-reviews__button-review"
                @click="$emit('reviewClick')">{{ commentText || $t('write_review') }}</button>
        </div>
        
        <div class="comments-and-reviews__comments"
            :data-loading="loading">

            <div v-for="comment in items"
                :key="comment.id"
                class="comment comments-and-reviews__comment"
                :id="'comment_' + comment.id"
                :class="{
                    'comments-and-reviews__comment_unvis': !visibleIds.includes(comment.id),
                    'comment_vis': visibleIds.includes(comment.id)
                }">
                <div class="comment__head">
                    <span class="rating comment__rating"
                        v-if="comment.stars > 0"
                        :data-value="parseInt(comment.stars)">
                    </span>
                    <div class="comment__user">
                        <html-link v-if="comment.createdBy && comment.createdBy.photo"
                            :url="comment.createdBy.htmlUrl"
                            class="comment__user-photo">
                            <img v-lazy-load :data-src="comment.createdBy.photo.url" />
                        </html-link>
                        <span v-else
                            class="comment__user-photo">
                            <img v-lazy-load :data-src="getUserNoImageLarge" />
                        </span>
                        <div class="comment__user-data">
                            <html-link v-if="comment.createdBy && comment.createdBy.htmlUrl"
                                :url="comment.createdBy.htmlUrl"
                                class="comment__name comment__name_link">
                                {{ get(comment, 'createdBy.fullName', $t('guest')) }}
                            </html-link>
                            <span v-else
                                class="comment__name">
                                {{ get(comment, 'createdBy.fullName', $t('guest')) }}
                            </span>
                            <svg-icon v-if="comment.expertOpinion"
                                class="comment__user-expert" 
                                name="verified" />
                            <span v-if="comment.createdAt"
                                class="comment__date">
                                {{ dateFormat(comment.createdAt) }}
                            </span>
                        </div>
                    </div>
                </div>
                <!-- eslint-disable-next-line -->
                <div v-html="(comment.text || '').replace(/(?:\r\n|\r|\n|\[BR]|\[br])/g, '<br>')" 
                    class="comment__text">
                </div>
                <span class="comment__user-comments"
                    v-if="comment.createdBy && countCommentsByUsers[comment.createdBy.id] > 1"
                    @click="toggleUserComments(comment)"
                    :data-show="$t('show_user_' + type)"
                    :data-hide="$t('hide_user_' + type)"
                    :data-filtered="comment.createdBy && filters.createdBy == comment.createdBy.id">
                </span>
                <div v-if="comment.pictures"
                    class="comment__photos">
                    <picture
                        v-for="(picture, index) in comment.pictures"
                        :key="picture.url"
                        class="comment__photo"
                        @click="showGallery({
                            pictures: comment.pictures,
                            user: comment.createdBy,
                            slideIndex: index
                        })">

                        <img v-lazy-load :data-src="picture.url"
                            :alt="picture.alt || ''" />
                    </picture>
                </div>
                <div class="comment__bottom">
                    <span class="comment__reply-btn"
                        @click.prevent="onReplyBtnClick(comment)">
                        {{ $t('reply') }}
                    </span>
                    <div class="comment__rate"
                        data-type="like"
                        @click.prevent="onRateBtnClick('like', comment)"
                        :data-active="comment.like">
                        <svg-icon class="comment__rate-icon" 
                            name="thumbs-up-filled"
                            data-filled />
                        <svg-icon class="comment__rate-icon" 
                            name="thumbs-up" />
                        <span class="comment__rate-value">{{ get(comment, 'ratings.likes', 0) }}</span>
                    </div>
                    <div class="comment__rate"
                        data-type="dislike"
                        @click.prevent="onRateBtnClick('dislike', comment)"
                        :data-active="comment.dislike">
                        <svg-icon class="comment__rate-icon" 
                            name="thumbs-down-filled"
                            data-filled />
                        <svg-icon class="comment__rate-icon" 
                            name="thumbs-down" />
                        <span class="comment__rate-value">{{ get(comment, 'ratings.dislikes', 0) }}</span>
                    </div>
                </div>    
                <div v-if="comment.replies"
                    class="comment__replies"
                    :data-expanded="showRepliesExpanded">
                    <div class="comment__replies-items">
                        <div v-for="reply in comment.replies"
                            :key="reply.id"
                            :id="'comment_' + reply.id"
                            class="comment comment_reply comment__reply">
                            <div class="comment__head">
                                <div class="comment__user">
                                    <html-link v-if="reply.createdBy && reply.createdBy.photo"
                                        :url="reply.createdBy.htmlUrl"
                                        class="comment__user-photo">
                                        <img v-lazy-load :data-src="reply.createdBy.photo.url" />
                                    </html-link>
                                    <span v-else
                                        class="comment__user-photo">
                                        <img v-lazy-load :data-src="getUserNoImageLarge" />
                                    </span>
                                    <div class="comment__user-data">
                                        <html-link v-if="reply.createdBy && reply.createdBy.htmlUrl"
                                            :url="reply.createdBy.htmlUrl"
                                            class="comment__name comment__name_link">
                                            {{ get(reply, 'createdBy.fullName', $t('guest')) }}
                                        </html-link>
                                        <span v-else
                                            class="comment__name">
                                            {{ get(reply, 'createdBy.fullName', $t('guest')) }}
                                        </span>
                                        <svg-icon v-if="reply.expertOpinion"
                                            class="comment__user-expert" 
                                            name="verified" />
                                        <span v-if="reply.createdAt"
                                            class="comment__date">
                                            {{ dateFormat(reply.createdAt) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <!-- eslint-disable-next-line -->
                            <div v-html="(reply.text || '').replace(/(?:\r\n|\r|\n|\[BR]|\[br])/g, '<br>')" 
                                class="comment__text">
                            </div>
                            <div class="comment__bottom">
                                <span class="comment__reply-btn"
                                    @click.prevent="onReplyBtnClick(reply, comment.id)">
                                    {{ $t('reply') }}
                                </span>
                                <div class="comment__rate"
                                    data-type="like"
                                    :data-active="reply.like"
                                    @click.prevent="onRateBtnClick('like', reply)">
                                    <svg-icon class="comment__rate-icon" 
                                        name="thumbs-up-filled"
                                        data-filled />
                                    <svg-icon class="comment__rate-icon" 
                                        name="thumbs-up" />
                                    <span class="comment__rate-value">{{ get(reply, 'ratings.likes', 0) }}</span>
                                </div>
                                <div class="comment__rate"
                                    data-type="dislike"
                                    :data-active="reply.dislike"
                                    @click.prevent="onRateBtnClick('dislike', reply)">
                                    <svg-icon class="comment__rate-icon" 
                                        name="thumbs-down-filled"
                                        data-filled />
                                    <svg-icon class="comment__rate-icon" 
                                        name="thumbs-down" />
                                    <span class="comment__rate-value">{{ get(reply, 'ratings.dislikes', 0) }}</span>
                                </div>
                            </div>  
                        </div>
                    </div>
                    <span class="comment__replies-btn"
                        @click="onRepliesExpandClick"
                        :data-show="[$t('show_replies'), numberDeclension(comment.replies.length, 'replies')].join(' ')"
                        :data-hide="[$t('hide_replies'), numberDeclension(comment.replies.length, 'replies')].join(' ')"></span>
                </div>
            </div>
        </div>

        <span v-if="restOfComments > 0"
            class="button-more comments-and-reviews__button-more button-more_centered"
            @click.prevent="onClickShowMore">
            {{ $t('show_more') }} {{ numberDeclension((restOfComments > perPage ? perPage : restOfComments), type) }}
        </span>
    </div>
</template>

<script>
import get from 'lodash/get';
import forEach from 'lodash/forEach';
import values from 'lodash/values';
import throttle from 'lodash/throttle';
import {mapGetters} from 'vuex';

import dayjs from 'dayjs';
import ProgressGroup from '@/components/ui/ProgressGroup';
import ButtonRectangle from '@/components/ui/buttons/ButtonRectangle';
import PerfumeShelves from '@/components/modal/perfume/PerfumeShelves';
import CommentsSort from '@/components/modal/perfume/CommentsSort';

export default {
    name: 'CommentsAndReviews',
    components: {
        ProgressGroup,
        ButtonRectangle,
        PerfumeShelves,
        CommentsSort,
    },
    props: {
        type: {
            type: String,
            default: 'comments'
        },
        page: {
            type: String,
            default: 'perfume'
        },
        startSort: {
            type: [Object],
            default: () => {
                return {
                    by: 'new',
                    dir: 'desc'
                }
            }
        },
        noFilter: {
            type: Boolean,
            default: false
        },
        noRating: {
            type: Boolean,
            default: false
        },
        asGift: {
            type: Boolean,
            default: false
        },
        ratings: {
            type: Object,
            default: () => {}
        },
        ratingsStars: {
            type: [String, Number],
            default: '0'
        },
        comments: {
            type: [Object, Array],
            default: () => {}
        },
        commentsTotal: {
            type: [String, Number],
            default: 0
        },
        commentText: {
            type: String,
            default: ''
        },
        ownershipStatus: {
            type: String,
            default: ''
        },
        onShelf: {
            type: Array,
            default: () => []
        },
        shelves: {
            type: Array,
            default: () => []
        },
        relationships: {
            type: Object,
            default: () => {}
        },
        perfumeLiked: {
            type: Boolean,
            default: false
        },
        hideShelfButtons: {
            type: Boolean,
            default: false
        },
        showReviewBtn: {
            type: Boolean,
            default: true
        },
        noSort: {
            type: Boolean,
            default: false
        },
        showRatingAndVotes: {
            type: Boolean,
            default: false
        },
        startVisibleCount: {
            type: Number,
            default: 20
        },
        startTotalCount: {
            type: Number,
            default: 100
        },
        entitySourceUrl: {
            type: String,
            default: null
        },
        perPage: {
            type: Number,
            default: 25
        },
        showRepliesExpanded: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dataItems: {},
            visibleIds: [],
            countCommentsByUsers: {},
            visibleCount: 0,
            total: 0,
            userRates: [],
            checkedShelves: [],
            popupShelvesShowed: false,
            popupSortShowed: false,
            delayedScrollElement: null,
            mounted: false,
            filters: {},
            filterFields: null,
            sort: {
                by: 'popular',
                dir: 'desc'
            },
            loading: false,
            commentsList: {}
        }
    },
    computed: {
        ...mapGetters(['getUserNoImageLarge', 'isDeviceDesktop']),
        items() {
            // console.log({'items':this.dataItems});
            return this.dataItems;
        },
        restOfComments() {
            return Math.max(this.total - this.visibleCount, 0);
        },
        votes() {

            const values = get(this, 'ratings.votes') || {
                five: {
                    total: 0
                },
                four: {
                    total: 0
                },
                three: {
                    total: 0
                },
                two: {
                    total: 0
                },
                one: {
                    total: 0
                }
            };

            Object.keys(values).forEach((key, index) => {
                values[key].name = this.$t('votes_' + key);
                values[key].checked = false;
            });

            return Object.values(values);
        },
        shelvesParams() {
            return {
                shelves: this.shelves,
                onShelf: this.checkedShelves
            }
        },
        filtersCount() {
            let counter = 0

            Object.values(this.filters).forEach(filter => {
                if (filter) {
                    if (Array.isArray(filter)) {
                        if (filter.length) {
                            counter++;
                        }
                    } else {
                        counter++;
                    }
                }
            })

            return counter;
        },
        ratingDeclensionGenitive() {
            return [
                this.$t('ratings_few'),
                this.$t('ratings_many'),
                this.$t('ratings_many')
            ]
        },
        reviewsDeclensionGenetive() {
            return [
                this.$t('reviews_few'),
                this.$t('reviews_many'),
                this.$t('reviews_many')
            ]
        }
    },
    watch: {
        visibleCount(value) {
            this.setVisible(value);
            this.$nextTick(this.renderShowMores);
        },
        onShelf(value) {
            this.checkedShelves = value
        },
    },
    globalBus: {
        'add-new-review'(review) {
            this.prependComment(review);

            this.$nextTick(() => {
                this.renderShowMore(this.$el.querySelector(`#comment_${review.id} .comment__text:not([data-show-more])`));
                this.scrollToComment(review.id);
            });
        },
        'add-new-comment'({comment, replyTo, topReplyTo}) {
            let parentComment;

            // Ответ
            if (replyTo || topReplyTo) {
                parentComment = this.dataItems['_'+(topReplyTo || replyTo)];
                if (parentComment) {
                    if (parentComment.replies) {
                        parentComment.replies.push(comment);
                    } else {
                        parentComment.replies = [comment];
                    }
                }
                this.touchData('items');
            } else {
                this.prependComment(comment);
                this.$nextTick(() => {
                    this.renderShowMore(this.$el.querySelector(`#comment_${comment.id} .comment__text:not([data-show-more])`));
                });
            }

            if (parentComment) {
                this.$nextTick(() => {
                    document.getElementById('comment_' + parentComment.id)
                        .querySelector('.comment__replies')
                        .setAttribute('data-expanded', true);

                    setTimeout(() => {
                        this.$scrollTo('#comment_' + comment.id, 750, {offset: -75});
                    }, 700);
                });
            }else{
                this.$nextTick(() => {
                    this.scrollToComment(comment.id);
                });
            }
        },
        'shelves-selected'(shelvesIds) {
            this.checkedShelves = shelvesIds;
        },

        'show-user-shelves-tooltip'() {
            if(this.isDeviceDesktop){
                this.popupShelvesShowed = true;
            }else{
                this.showPopup('shelves', this.shelvesParams);
            }
        },

        'comments-sort-type-change'(value) {
            this.sort.by = value;
            this.popupSortShowed = false;
            this.updateComments();
        },

        'comments-sort-order-change'(value) {
            this.sort.dir = value;
            this.popupSortShowed = false;
            this.updateComments();
        },

        'filters-update'(value) {
            this.$api.get(this.entitySourceUrl + '/comments', {
                params: {
                    ...this.retranslateFilters(value),
                    count_total: 'y'
                }
            }).then((response) => {
                this.$bus.$emit('comments-filtered', response.data.total);
            });
        },

        'filters-save'(value) {
            this.filters = value;
            this.updateComments();
        }
    },
    created() {
        this.commentsList = this.comments;

        this.collectDataItems(this.commentsList);
        this.visibleCount = this.startVisibleCount;
        this.setVisible(this.visibleCount);

        this.sort = this.startSort || this.sort;
        this.checkedShelves = this.onShelf;
    },
    mounted() {
        this.loadListeners();
        this.loadUserData();

        // this.checkHash();

        this.$nextTick(() => {
            this.mounted = true;

            if (this.delayedScrollElement) {
                console.log('found hydrated', this.delayedScrollElement);
                setTimeout(() => this.scrollToComment(this.delayedScrollElement, this.showRepliesExpanded), 700);
            }
        });
    },
    methods: {
        get,
        touchData(name) {
            if (this[name]) {
                this[name].__ob__.dep.notify();
            }
        },
        /**
         * Собирает данные для комментариев
         * 
         * @param  {Object} collection
         */
        collectDataItems(collection = {}) {

            this.countCommentsByUsers = {};

            const comments = collection && collection.items ? collection.items : [];

            // let comments = collection.items || [];
            // if (this.$auth.loggedIn) {
            //     const userComments = comments.filter((c) => get(c, 'createdBy.id') === this.$auth.user.id);
            //     if (userComments.length) {
            //         comments = comments.filter((c) => get(c, 'createdBy.id') !== this.$auth.user.id);
            //         comments = userComments.concat(comments);
            //     }
            // }

            forEach(comments, (comment) => {
                this.dataItems['_' + comment.id] = comment;
                if (comment.createdBy && comment.createdBy.id) {
                    if (!this.countCommentsByUsers[comment.createdBy.id]) {
                        this.countCommentsByUsers[comment.createdBy.id] = 0;
                    }
                    this.countCommentsByUsers[comment.createdBy.id] += 1;
                }
            });

            this.total = collection && collection.total ? collection.total : 0;
        },
        /**
         * Добавляет комментарий в начало
         */
        prependComment(comment) {
            
            if (comment && comment.id) {
                const comments = {};
                comments['_' + comment.id] = comment;
                forEach(this.dataItems, (comment) => {
                    comments['_' + comment.id] = comment;
                });

                this.dataItems = comments;
                this.setVisible(this.visibleCount + 1);
                this.total += 1;

                this.$emit('comments-count-updated', {
                    value: this.countCommentsWithReplies(),
                    firstLevel: this.total
                });
            }
        },
        /**
         * Возвращает кол-во комментариев и ответов
         * 
         * @return {Number}
         */
        countCommentsWithReplies() {

            let total = 0;
            forEach(this.dataItems, (comment) => {

                total += 1;
                if (comment.replies) {
                    total += comment.replies.length;
                }
            });

            return total;
        },
        /**
         * Устанавливает видимыми комментарии
         * 
         * @param {Number} value кол-во
         */
        setVisible(value) {
            this.visibleIds = values(this.items).slice(0, value).map((item) => item.id);
        },
        /**
         * Форматирует дату
         * @param  {String} date 
         * @return {String}
         */
        dateFormat(date){
            return dayjs(new Date(date)).format('DD.MM.YYYY '+ this.$t('at') +' HH:mm');
        },
        /**
         * Открывает галерею
         * @param  {Object} params
         */
        showGallery(params) {
            this.showPopup('gallery', Object.assign(params, {size: 'big'}));
        },
        /**
         * Загружает всё, что относится к текущему пользователю
         */
        loadUserData() {
            if (this.$auth.loggedIn) {
                this.loadUserRates();
            }
        },
        /**
         * Загружает комментарии при пагинации
         */
        loadNextComments() {
            const url = this.entitySourceUrl + '/comments';

            this.$api.get(url, {
                params: {
                    page: this.commentsList.nextPage,
                    ...this.retranslateFilters(this.filters),
                    per_page: this.startTotalCount,
                    ...this.retranslateSort(this.sort.by, this.sort.dir)
                }
            })
                .then((response) => {
                    this.commentsList = response.data;
                    this.collectDataItems(response.data);
                    this.setVisible(this.visibleCount);
                    this.touchData('items');
                    this.$nextTick(() => {
                        this.renderShowMores();
                        this.loadUserData();
                    });
                });
        },
        /**
         * Обновляет комментарии
         */
        updateComments() {
            const url = this.entitySourceUrl + '/comments';

            this.loading = true;

            this.$api.get(url, {
                params: {
                    ...this.retranslateFilters(this.filters),
                    per_page: this.startTotalCount,
                    ...this.retranslateSort(this.sort.by, this.sort.dir)
                }
            })
                .then((response) => {
                    this.commentsList = response.data;
                    this.dataItems = {};
                    this.collectDataItems(response.data);
                    this.visibleCount = this.startVisibleCount;
                    this.setVisible(this.visibleCount);
                    this.touchData('items');
                    this.$nextTick(() => {
                        this.renderShowMores();
                        this.loadUserData();
                    });

                    this.scrollToTop();

                    this.loading = false;
                });
        },
        /**
         * Переводит фильтры фронтенда на бэкенд
         * 
         * @param  {Object} filters
         * @return {Object}
         */
        retranslateFilters(filters) {

            const params = {};
            let value;

            for (const key in filters) {
                value = filters[key];

                switch (key) {
                case 'onlyPhotos':
                    if (value) {
                        params.with_photo = 'y';
                    }
                    break;
                case 'genders':
                    if (value && value.length) {
                        params.gender = value.join(',');
                    }
                    break;
                case 'countries':
                    if (value && value.length) {
                        params.country = value.join(',');
                    }
                    break;
                case 'votes':
                    if (value && value.filter((v) => v).length) {
                        params.stars = value.filter((v) => v).join(',');
                    }
                    break;
                case 'createdBy':
                    if (value) {
                        params.created_by = value;
                    }
                    break;
                default:
                    params[key] = filters[key];
                    break;
                }
            };

            return params;
        },
        /**
         * Переводит сортировку в значение для бэкенда
         * 
         * @param  {String} by
         * @param  {String} order
         * @return {Object}
         */
        retranslateSort(by, dir = 'asc') {

            const sort = {
                sort: by,
                order: dir
            };

            switch (by) {
            case 'popular':
                sort.sort = 'likes';
                break;
            case 'rating':
                sort.sort = 'stars';
                break;
            case 'new':
                sort.sort = 'createdAt';
                break;
            }

            return sort;
        },
        /**
         * Загружает и отображает лайки и дизлайки пользователей
         */
        loadUserRates() {
            const id = [];

            forEach(this.items, (comment) => {
                comment.rates || id.push(comment.id);
            });

            this.$api.get(this.entitySourceUrl + '/comments/ratings', {
                params: {
                    'created_by': this.$auth.user.id,
                    'per_page': 100
                }
            })
                .then((response) => {
                    if (response.data && response.data.items) {
                        forEach(response.data.items, (item) => {
                            if (this.dataItems['_'+item.comment.id]) {
                                this.dataItems['_'+item.comment.id][item.type] = true;
                            } else {
                                // ищем среди ответов
                                forEach(this.dataItems, (comment, ci) => {
                                    if (comment.replies) {
                                        forEach(comment.replies, (reply, ri) => {
                                            // eslint-disable-next-line
                                            if (reply.id == item.comment.id) {
                                                this.dataItems[ci].replies[ri][item.type] = true;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }

                    this.touchData('items');
                });
        },
        /**
         * Загружает "слушателей" событий
         */
        loadListeners() {
            this.$bus.$on('via-auth-action', (params) => {
                params.callback();
            });
        },
        /**
         * Рисует "Показать польностью" у всех комментариев
         */
        renderShowMores() {
            const $texts = this.$el.querySelectorAll('.comment_vis .comment__text:not([data-show-more])');

            for (let i = 0; i < $texts.length; i++) {
                this.renderShowMore($texts[i]);
            }
        },
        /**
         * Рисует "Показать польностью" у комментария
         */
        renderShowMore($elem) {
            if($elem){
                if ($elem.scrollHeight > $elem.clientHeight) {
                    $elem.innerHTML += '<span class="comment__text-expand" data-expand="'+ this.$t('read_more') +'" data-collapse="'+ this.$t('collapse') +'"></span>';
                    $elem.setAttribute('data-show-more', true);
                    $elem.querySelector('.comment__text-expand')
                        .addEventListener('click', this.onTextEpandClick);
                }
            }
        },
        /**
         * Выполняется при клике на "Показать полностью"
         * 
         * @param  {Object} event
         */
        onTextEpandClick(event) {

            const target = event.target.classList.contains('comment__text')
                ? event.target
                : event.target.parentNode;

            this.toggleAndScroll(target);
        },
        /**
         * Выполняется при клике на "Показать ответы"
         * 
         * @param  {Object} event
         */
        onRepliesExpandClick(event) {

            this.toggleAndScroll(event.target.parentNode);
        },
        /**
         * Выполняется при клике на "Ответить"
         * 
         * @param  {Object} comment
         */
        onReplyBtnClick(comment, topParentId) {
            this.$authEmit('via-auth-action', {
                id: comment.id,
                callback: () => {
                    this.showPopup('popup-comment', {
                        page: this.page,
                        replyTo: comment.id,
                        topReplyTo: topParentId || comment.topParentId,
                        replyName: (comment.createdBy.name || '') 
                    });
                }
            });
        },
        /**
         * Выполняется при клике на лайк/дизлайк
         * 
         * @param  {String} type
         * @param  {Object} comment
         */
        onRateBtnClick(type, comment) {
            this.$authEmit('via-auth-action', {
                callback: () => {
                    this.rateComment(comment, type);   
                }
            });
        },
        /**
         * Выполняется при клике на "Показать ещё"
         */
        onClickShowMore() {
            this.visibleCount += this.perPage;

            if ((this.visibleCount >= this.commentsList.perPage * this.commentsList.currentPage) 
                && get(this.commentsList, 'nextPage')) {
                this.loadNextComments();
            }
        },
        /**
         * Выполняется при клике на шкалу фильтра по оценкам
         *  
         * @param  {Number} index
         */
        onRatingFilterClick(index) {
            const value = index+1;

            if (!this.filters.votes) {
                this.filters.votes = [];
            }

            if (this.filters.votes[index]) {
                delete this.filters.votes[index];
            } else {
                this.filters.votes[index] = value;
            }

            if (this.filters.votes.filter((v) => v).length < 1) {
                delete this.filters.votes;
            }

            this.updateComments();
        },
        /**
         * Ставит или снимает лайк/дизлайк
         * 
         * @param  {String} type
         * @param  {Object} comment
         */
        rateComment(comment, type) {
            
            if (!this.$actions.checkOrLock('rateComment' + comment.id + type)) {
                return false;
            }

            const yet = comment.like ? 'like' : comment.dislike ? 'dislike' : null; // Существующее значение
            const newValue = yet && comment[type] ? null : type; // Новое значение лайка/дизлайка
            const $comment = document.getElementById('comment_' + comment.id);
            const isChangeType = (comment.like || comment.dislike) && newValue && !comment[type];

            // Убираем активность с обеих кнопок
            forEach($comment.querySelectorAll('.comment__rate'), ($rate) => {
                $rate.removeAttribute('data-active');
            });
            // Устанавливаем (при необходимости) активность нажатой
            !newValue || $comment.querySelector('.comment__rate[data-type="'+ type +'"]')
                .setAttribute('data-active', true);

            const method = newValue || isChangeType ? 'post' : 'delete';
            const params = newValue || isChangeType ? {type} : {data: {type}};
            this.$api[method](this.entitySourceUrl + '/comments/' + comment.id + '/ratings', params)
                .then((response) => {
                    // Ставим новые числа
                    forEach($comment.querySelector('.comment__bottom')
                        .querySelectorAll('.comment__rate'), ($rate) => {
                        const type = $rate.getAttribute('data-type');
                        $rate.querySelector('.comment__rate-value')
                            .textContent = (response.data[type + 's'] ? response.data[type + 's'].total : 0);
                    });

                    delete comment.like;
                    delete comment.dislike;

                    if (newValue) {
                        comment[type] = true;
                    }
                })
                .catch((response) => {
                    switch (response.code) {
                    case 'like-already-exists':
                    case 'dislike-already-exists':
                    case 'authorization-failed':
                        break;

                    default:
                        this.$alert.error(this.$t('alerts.error'));
                        break;
                    }
                })
                .finally(() => {
                    this.$actions.unlock('rateComment' + comment.id + type);
                });
        },
        /**
         * Скроллит наверх в случае необходимости (когда экран внизу)
         */
        scrollToTop() {

            const $top = document.querySelector('.comments-and-reviews__comments');

            if ($top.getBoundingClientRect().top < 0) {
                this.$scrollTo($top, 500, {offset: -72});
            }
            
        },
        /**
         * Переключает атрибут data-expanded у блока и скроллит к нему в случае необходимости
         * 
         * @param  {Object} $block
         * @param  {Boolean} noToggle
         */
        toggleAndScroll($block, noToggle) {

            let timeout = 0;

            if ($block.hasAttribute('data-expanded')) {
                if ($block.getBoundingClientRect().top < 0) {
                    this.$scrollTo($block.parentNode, $block.clientHeight, {offset: -72});
                    timeout = $block.clientHeight/2;
                }
            }

            if(!noToggle) setTimeout(() => $block.toggleAttribute('data-expanded'), timeout);
        },
        /**
         * Переключает фильтр по пользователю
         * 
         */
        toggleUserComments(comment) {
            if (this.filters.createdBy) {
                delete this.filters.createdBy;
            } else {
                this.filters.createdBy = comment.createdBy.id;
            }
            this.updateComments();
        },
        /**
         * Открывает попап с фильтром
         */
        showFilter() {
            let currentOptions = {};

            if (this.isDeviceDesktop) {
                currentOptions = {
                    loadedOverlay: false,
                    fullscreen: false,
                    draggable: false,
                    type: 'right',
                    classes: 'modal__box_no_radius',
                    width: '26%',
                    height: '100%'
                };
            }
            
            const show = () => {
                this.showPopup('comments-filter', {
                    filters: this.filters,
                    page: this.page,
                    fields: this.filterFields
                }, currentOptions, {
                    closeClick: () => this.$bus.$emit('filters-closed'),
                    opened: () => this.$bus.$emit('filters-opened')
                });
            };

            if (!this.filterFields) {
                this.$api.get(this.entitySourceUrl + '/comments/filters')
                    .then((response) => {
                        this.filterFields = response.data;
                        show();
                    });
            } else {
                show();
            }
        },
        /**
         * Прокручивает экран к области комментария
         * 
         * @param  {Number} id
         * @param  {Boolean} noToggle
         */
        scrollToComment(id, noToggle) {

            if (this.delayedScrollElement) {
                this.delayedScrollElement = null;
            };

            // Ещё не гидрирован компонент
            if (!this.mounted) {
                console.log('not hydrated', id);
                this.delayedScrollElement = id;
                return;
            }

            const $comment = document.getElementById('comment_' + id);

            console.log("try to find comment: ", 'comment_' + id, $comment);

            if ($comment) {

                const visible =  this.$options.filters.contentVisible($comment);
                const inViewPort = this.$options.filters.contentInViewport($comment);
                let isReply = false;

                console.log({
                    visible,
                    inViewPort
                });

                // Комментарий виден на экране
                if (visible && inViewPort) {
                    return;
                };

                // Комментарий-ответ
                if ($comment.classList.contains('comment_reply')) {
                    isReply = true;
                    this.toggleAndScroll($comment.parentNode.parentNode, noToggle);
                }

                // Комментарий скрыт под "Показать еще..."
                if (!visible && !inViewPort) {
                    this.visibleCount = 1000;

                    setTimeout(() => {
                        console.log('ok, scroll to hidden comment');
                        this.$nextTick(() => this.$scrollTo('#comment_' + id, 1150, {offset: isReply ? -150 : -75}));
                    }, 700);
                    return;
                };

                setTimeout(() => {
                    this.$nextTick(() => {
                        this.$scrollTo($comment, 750, {offset: -75});
                    });
                }, 700);
            }
        },
        /**
         * Проверяет хэш на наличие id комментария и скроллит
         */
        checkHash() {

            const hashCommentId = this.getCommentIdFromHash();
            if (hashCommentId) {
                this.scrollToComment(hashCommentId);
            }
        },
        /**
         * Получает id комментария из хэша
         * 
         * @return {Number}
         */
        getCommentIdFromHash() {
            const hash = this.$route.hash;
            const r = /\d+/;

            return parseInt(get(hash.match(r), '[0]')) || null;
        },
        /**
         * Показывает попап с полками
         * 
         * @param  {Boolean} value
         */
        setShelvesShowed: throttle(function(value) {
            if (this.shelves.length > 0) {
                this.popupShelvesShowed = value;
            }
        }, 200),
        /**
         * Показывает мобильный попап сортировки
         */
        showSortPopup() {
            this.showPopup('comments-sort', {
                sortType: this.sort.by,
                sortOrder: this.sort.dir,
                page: this.page
            });
        },
        /**
         * Возвращает текст "N ответов [оценок и т.д.]"
         * 
         * @param  {Number} number
         * @param  {String} type
         * @return {String}         
         */
        numberDeclension(number, type) {
            return this.$options.filters.numberDeclension(number, [
                this.$t(type + '_one'),
                this.$t(type + '_few'),
                this.$t(type + '_many'),
            ]);
        },
        /**
         * Показывает попап рекомендации подарка
         */
        showRecomendation() {
            const ratings = this.$options.filters.numberDeclension(get(this.ratings, 'total', 0), this.ratingDeclensionGenitive);
            let reviews = this.$options.filters.numberDeclension(
                this.commentsTotal,
                this.reviewsDeclensionGenetive
            )

            if(this.page === 'post') {
                reviews = this.$options.filters.numberDeclension(
                    this.commentsTotal,
                    this.reviewsDeclensionGenetive
                )
            }

            const content = this.$t('info_text', {ratings, reviews});

            this.showPopup('tooltip', {
                title: this.$t('info'),
                content
            });
        }
    }
}
</script>

<style lang="less">
.comments-and-reviews {

    &__header-wrapper {
        contain-intrinsic-size: 1px rem(233);
        content-visibility: auto;

        @{desktop} & {
            display: flex;
            justify-content: space-between;
            contain-intrinsic-size: 1px rem(235);
        }

        .comments-visible & {
            content-visibility: visible;
        }
    }

    &__right-wrapper {
        @{desktop} & {
            padding-top: rem(18);
        }
    }

    &__left-column {
        @{desktop} & {
            width: rem(255);
        }
    }

    &__right-column {
        text-align: end;
    }

    &__ratings {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        padding-top: rem(6);
        .page-padding();

        @{desktop} & {
            padding-top: rem(8);
        }

    }

    &__value {
        font-size: rem(36);

        transform: translateY(rem(3));

        @{desktop} & {
            line-height: 1.3;
        }
    }

    &__fire {
        display: flex;
        align-items: center;
        justify-content: center;

        background: none;
        border: rem(1) solid @color-gray-white;
        border-radius: 50%;

        margin-left: rem(12);
        padding: 0;

        height: rem(32);
        width: rem(32);

        transition: border-color .15s ease;

        & > svg {
            height: rem(16);
            width: rem(24);
        }

        .hover({
            border-color: @color-primary;
        });
    }

    &__stars-wrapper {
        display: flex;
        align-items: center;

        margin-bottom: rem(16);
        margin-left: rem(-2.5);

        .page-padding();
    }

    &__stars {
        --star-height: rem(16);
        --star-width: rem(20);
    }

    &__reviews-count {
        font-size: rem(13);
        font-weight: 500;

        margin-left: rem(4);

        /* fontfix */
        transform: translateY(rem(3));
    }

    &__votes {
        margin-bottom: rem(7);
        display: flex;
        flex-direction: column-reverse;

        @{desktop} & {
            width: rem(296);
        }

        .progress-group__item{
            &:last-child{
                margin-bottom: rem(5);
            }

            &:first-child{
                margin-bottom: 0;
            }
        }
    }

    &__buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;

        margin-bottom: rem(3);
        padding: rem(16) rem(30);

        &_empty-review {
            margin-bottom: 0;
        }

        @{desktop} & {
            position: relative;
            top: rem(-7);
        }
    }

    &__button {
        
        @{mobile} & {
            width: rem(44);
            padding: rem(50) 0 0;
            position: relative;
            border: none;
            text-align: center;

            &::before{
                width: rem(44);
                height: rem(44);
                border: rem(1) solid;
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                border-radius: 100%;
            }

            &.button-rectangle_bordered{
                .button-rectangle__icon{
                    width: rem(18);
                    height: rem(18);
                }
            }

            &>svg{
                width: rem(18);
                height: rem(18);
                position: absolute;
                top: rem(13);
                left: 50%;
                margin-left: rem(-9);
            }
        }

        @{desktop} & {
            border-radius: rem(3);
            margin: 0 rem(4);
            --size: rem(44);
            font-size: rem(13);
        }

        &_owner {
            &.button-rectangle_active,
            &.button-circle_active {
                cursor: default;
            }
        }

        &[data-disabled] {
            pointer-events: none;
            opacity: .7;
        }
    }

    &__sort-and-filter {
        display: flex;
        align-items: center;
        justify-content: space-between;

        border-bottom: rem(1) solid @color-gray-white;
        font-size: rem(12);

        padding-top: rem(23);
        padding-bottom: rem(11);
        .page-padding();

        @media @min375 {
            font-size: rem(13);
        }

        &_no-padding-top {
            padding-top: 0;
        }

        @{desktop} & {
            margin-top: rem(0);
            padding-top: rem(18);

            position: relative;
        }
    }

    &__sort-and-filter + &__button-wrapper {
        @{desktop} & {
            margin-top: rem(16);
        }
    }

    &__sort {

        &-wrapper:hover &-type {
            @media @hover {
                color: @color-primary;
            }
        }

        &-title {
            color: @color-black !important;
        }

        &-type {
            font-weight: 500;

            padding-left: rem(4);
        }

        &-icon {
            height: rem(11);
            width: rem(11);

            position: relative;
            top: rem(-1);
            left: rem(2);

            transition: transform .15s ease;

            &_rotated {
                transform: rotateZ(180deg);
            }
        }

        &-wrapper {
            white-space: nowrap;

            position: absolute;
            top: rem(18);
            left: 0;
        }
    }

    &__filter {
        font-weight: 500;

        @{desktop} & {
            margin-left: auto;
        }

        .hover({
            color: @color-primary;
        });
    }

    &__sort,
    &__filter {
        background: none;
        border: none;

        padding: 0;

        transition: color .3s ease;
    }

    &__button-wrapper {
        margin-top: rem(16);

        .page-padding();

        &:first-child {
            margin-top: rem(10);
        }

        &:last-child {
            padding-bottom: rem(16);
        }

        &_empty-review {
            margin-bottom: rem(20);
            margin-top: rem(26);
        }

        @{desktop} & {
            margin-top: rem(36);

            &_no-votes{
                margin-top: rem(16);
            }
        }
    }

    &__button-review {
        display: flex;
        align-items: center;

        background-color: @color-gray-light-2;
        border: none;
        border-radius: rem(3);
        color: @color-gray;
        font-size: rem(15);
        white-space: nowrap;

        height: rem(48);
        width: 100%;

        .page-padding();

        transition: background-color .15s ease;

        .hover({
            background: @color-gray-white;
        });

        @{desktop} & {
            padding: rem(4) @dim-page-padding 0;
        }
    }

    &__button-more {
        border-top: rem(1) solid @color-gray-white;
        display: block;
        cursor: pointer;
    }


    &__shelves {
        position: relative;

        &-wrapper {
            @{desktop} & {
                padding: 0;
            }
        }

        &-popup {
            position: absolute;
            top: 100%;
            right: 0;
        }

        button {

            @{desktop} & {
                margin-right: 0;
            }
        }
    }

    &__comments {
        transition: all .1s linear;
        padding-bottom: rem(29);

        &[data-loading="true"] {
            opacity: .5;
            pointer-events: none;
            filter: blur(3px);
        }

        @{desktop} & {
            // padding-top: rem(20);
        }
    }

    &__comment{
        margin-top: rem(29);

        &_unvis{
            visibility: hidden;
            pointer-events: none;
            position: absolute;
            left: -9999px;
            top: -9999px;
            padding: 0;
            width: 0;
            height: 0;
            overflow: hidden;
        }
    }
}

.comment{
    --photo-size: rem(40);
    border-top: rem(1) solid @color-gray-white;
    padding-top: rem(20);

    &:first-child{
        border-top: 0;
        padding-top: 0;
    }

    @{mobile} &{
        padding-left: rem(20);
        padding-right: rem(20);
    }

    &_reply{
        padding-left: rem(20);
        box-shadow: inset rem(2) 0 0 @color-gray-white;
        border-top: 0;
        padding-top: 0;
    }

    &__reply{
        margin-top: rem(24);
    }

    &__replies{

        &[data-expanded] {
            .comment__replies-items{
                padding: rem(7) 0 rem(20);
                height: auto;
                pointer-events: auto;
            }
            .comment__replies-btn:before{
                content: attr(data-hide);
            }
        }

        &-items{
            height: 0;
            overflow: hidden;
            padding: 0;
            margin: 0;
            pointer-events: none;
        }

        &-btn{
            display: inline-block;
            background: @color-gray-light-2;
            border: none;
            border-radius: rem(3);
            color: @color-black;
            font-size: rem(13);
            padding: rem(10) rem(18) rem(9);
            line-height: 1;
            transition: background-color .1s ease;
            cursor: pointer;
            margin-top: rem(14);

            &:before{
                content: attr(data-show);
            }

            .hover({
                background: @color-gray-white;
            });

            &:active {
                background: @color-gray-white;
            }
        }
    }

    &__head{
        overflow: hidden;
        position: relative;
        height: var(--photo-size);
        contain-intrinsic-size: rem(1) var(--photo-size);
        content-visibility: auto;
    }

    &__user{
        margin-right: rem(120);
        padding-top: rem(1);

        &-photo{
            position: absolute;
            display: block;
            text-decoration: none;
            left: 0;
            top: 0;
            width: var(--photo-size);
            height: var(--photo-size);

            &>img{
                display: block;
                width: var(--photo-size);
                height: var(--photo-size);
                border-radius: 100%;
            }
        }

        &-data{
            margin-left: var(--photo-size);
            padding-left: rem(16);
            white-space: nowrap;
        }

        &-expert{
            display: inline-block;
            width: rem(17);
            position: relative;
            height: rem(17);
            left: 1px;
            top: 2px;
            vertical-align: top;
        }
    }

    &__name{
        font-weight: 500;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        overflow: hidden;
        vertical-align: top;
        display: inline-block;

        &_link{
            color: @color-black;
            transition: color .15s ease;

            .hover({
                color: @color-primary;
            });
        }
    }

    &__date{
        display: block;
        color: @color-gray;
        font-size: rem(13);
        margin: rem(2) 0 0;
    }

    &__rating{
        &.rating{
            position: absolute;
            right: 0;
            top: 5px;
            --star-width: rem(17);
            --star-height: rem(14);
        }
    }

    &__text{
        word-break: break-word;
        line-height: rem(23);
        margin-top: rem(21);
        overflow: hidden;
        max-height: rem(20*23);
        position: relative;

        @{mobile} &{
            // line-height: 155%;
        }

        &[data-expanded]{
            max-height: 100%;
            padding-bottom: rem(23);

            .comment__text-expand{
                background: transparent;
                &:before{
                    content: attr(data-collapse);
                }
            }
        }

        &-expand{
            position: absolute;
            left: 0;
            bottom: 0;
            height: rem(2*23);
            right: 0;
            background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.99) 50%);
            pointer-events: none;

            &:before{
                content: attr(data-expand);
                position: absolute;
                left: 0;
                bottom: 0;
                color: @color-violet;
                pointer-events: auto;
                cursor: pointer;
                display: inline-block;
                border-bottom: 1px solid transparent;
                line-height: rem(15);
                transition: border-color .15s ease;
            }

            .hover({
                &:before{
                    border-color: @color-violet;
                }
            });
        }
    }

    &__user-comments{
        display: block;
        pointer-events: none;
        padding-top: rem(4);

        &:before{
            content: attr(data-show);
            color: @color-violet;
            pointer-events: auto;
            cursor: pointer;
            display: inline-block;
            border-bottom: 1px solid transparent;
            line-height: rem(15);
            transition: border-color .1s ease;
        }

        .hover({
            &:before{
                border-color: @color-violet;
            }
        });

        &[data-filtered="true"] {
            &:before{
                content: attr(data-hide);
            }
        }
    }

    &__photos{
        font-size: 0;
        padding: rem(5) 0 0;
    }

    &__photo{
        display: inline-block;
        vertical-align: top;
        cursor: pointer;
        margin: rem(12) rem(12) 0 0;
        transition: opacity .1s ease;

        .hover({
            opacity: .8;
        });

        &>img{
            object-fit: cover;
            border-radius: rem(3);
            height: rem(56);
            width: rem(56);
            display: inline-block;
        }
    }

    &__bottom{
        overflow: hidden;
        padding: rem(16) 0 0 0;
    }

    &__reply-btn{
        float: right;
        color: @color-gray-contrast;
        transition: color .1s ease;
        cursor: pointer;

        .hover({
            color: @color-primary;
        });
    }

    &__rate{
        display: inline-block;
        vertical-align: top;
        font-size: rem(13);
        color: @color-gray-light;
        cursor: pointer;
        transition: color .1s ease;
        margin-right: rem(14);
        font-weight: 500;
        .noSelection;

        .hover({
            color: @color-gray;
        });

        &[data-active="true"],
        &[data-active="1"] {
            color: @color-black;
            .hover({
                color: @color-black;
            });

            .comment__rate-icon {
                display: none;

                &[data-filled]{
                    display: inline-block;
                }
            }
        }

        &-icon{
            height: rem(20);
            width: rem(22);
            display: inline-block;
            position: relative;
            top: rem(-1);

            &[data-filled] {
                display: none;
            }
        }


    }
}
</style>